import React, { useState } from 'react';
import { Paper, Tabs, Tab, Box, Typography } from '@mui/material';
import ChatIcon from '@mui/icons-material/Chat';
import BoltIcon from '@mui/icons-material/Bolt';
import ChatPanel from './ChatPanel';
import OneClickPanel from './OneClickPanel';

export default function LlmAssistantPanel({ jobId }) {
  const [tab, setTab] = useState(0);

  if (!jobId) return null;

  return (
    <Paper
      elevation={2}
      sx={{
        mt: 3,
        p: { xs: 1.5, md: 2 },
        borderRadius: 2,
      }}
    >
      <Box display="flex" alignItems="center" gap={1} mb={1}>
        <Typography variant="h6">KI-Assistent</Typography>
        <Typography variant="caption" color="text.secondary">
          Arbeite mit deinem Transkript: Fragen stellen oder 1-Click-Aktionen nutzen.
        </Typography>
      </Box>

      <Tabs
        value={tab}
        onChange={(_, v) => setTab(v)}
        variant="fullWidth"
        sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}
      >
        <Tab icon={<ChatIcon />} iconPosition="start" label="Chat" />
        <Tab icon={<BoltIcon />} iconPosition="start" label="1-Click" />
      </Tabs>

      <Box role="tabpanel" hidden={tab !== 0}>
        {tab === 0 && <ChatPanel jobId={jobId} />}
      </Box>
      <Box role="tabpanel" hidden={tab !== 1}>
        {tab === 1 && <OneClickPanel jobId={jobId} />}
      </Box>
    </Paper>
  );
}
